/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { LogSourceLocation } from '../models/LogSourceLocation';

export class LogSource {
  /**
  * Log source ID.
  */
  'id': string;
  /**
  * Log source display name.
  */
  'name'?: string;
  /**
  * Type of log source.
  */
  'type': LogSourceTypeEnum;
  /**
  * ID of the parent resource (e.g., S3 bucket) where this log source is located.
  */
  'locationResourceId'?: string;
  'location'?: LogSourceLocation;
  /**
  * ID of the LLG policy this log source is attached to, if any.
  */
  'attachedPolicyId'?: string;
  /**
  * When the log source was created.
  */
  'createdAt'?: Date;
  /**
  * When the log source was last updated.
  */
  'updatedAt'?: Date;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "id",
      "baseName": "id",
      "type": "string",
      "format": ""
    },
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "type",
      "baseName": "type",
      "type": "LogSourceTypeEnum",
      "format": ""
    },
    {
      "name": "locationResourceId",
      "baseName": "locationResourceId",
      "type": "string",
      "format": ""
    },
    {
      "name": "location",
      "baseName": "location",
      "type": "LogSourceLocation",
      "format": ""
    },
    {
      "name": "attachedPolicyId",
      "baseName": "attachedPolicyId",
      "type": "string",
      "format": ""
    },
    {
      "name": "createdAt",
      "baseName": "createdAt",
      "type": "Date",
      "format": "date-time"
    },
    {
      "name": "updatedAt",
      "baseName": "updatedAt",
      "type": "Date",
      "format": "date-time"
    }  ];

  static getAttributeTypeMap() {
    return LogSource.attributeTypeMap;
  }

  public constructor() {
  }
}


export enum LogSourceTypeEnum {
  Cloudtrail = 'CLOUDTRAIL',
  Datadog = 'DATADOG',
  Cloudwatch = 'CLOUDWATCH',
  Splunk = 'SPLUNK'
}

